import { render } from "./NewsDropDown.vue?vue&type=template&id=f0d99f20&scoped=true&ts=true"
import script from "./NewsDropDown.vue?vue&type=script&lang=ts"
export * from "./NewsDropDown.vue?vue&type=script&lang=ts"

import "./NewsDropDown.vue?vue&type=style&index=0&id=f0d99f20&lang=scss&scoped=true"

import exportComponent from "D:\\CTL-Project\\map-web-4\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0d99f20"]])

export default __exports__